import { render, staticRenderFns } from "./EcReviewModal.vue?vue&type=template&id=131acdc4&"
import script from "./EcReviewModal.vue?vue&type=script&lang=js&"
export * from "./EcReviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports